import { Card, Stack, Typography, Switch, ToggleButtonGroup, ToggleButton } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { toggleVisibility } from "Redux/inventorySlice";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Api from "Api";
import { useQuery } from "@tanstack/react-query";
import { changeMode, FleetModeType } from "Redux/fleetSlice";
import FleetDialoig from "../fleetDialog";

export default function Fleet() {
  const dispatch = useAppDispatch();

  const { visible } = useAppSelector((state) => state.inventory);
  const { mode } = useAppSelector((state) => state.fleet);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleVisible = () => {
    dispatch(toggleVisibility());
  };

  const handleMode = (event: React.MouseEvent<HTMLElement>, newMode: FleetModeType) => {
    dispatch(changeMode(newMode));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <ToggleButtonGroup value={mode} exclusive onChange={handleMode} aria-label="heatMap2-mode">
          <ToggleButton
            value="cars"
            aria-label="cars-mode"
            style={{
              width: "56px",
              height: "56px",
              backgroundColor: mode === "cars" ? "#4754CA" : "",
              color: mode === "cars" ? "#fff" : "",
            }}
          >
            خودروها
          </ToggleButton>
          <ToggleButton
            value="drivers"
            aria-label="drivers-mode"
            style={{
              width: "56px",
              height: "56px",
              backgroundColor: mode === "drivers" ? "#4754CA" : "",
              color: mode === "drivers" ? "#fff" : "",
            }}
          >
            رانندگان
          </ToggleButton>
        </ToggleButtonGroup>

        <FleetDialoig />
        <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleVisible} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
